export const radius = {
    xs: '2px',
    small: '4px',
    medium: '8px',
    large: '16px',
    xl: '20px',
}

export const stroke = {
    small: '0.5px',
    medium: '1px',
    large: '2px',
}
